import eventBus from "../events/eventBus";
import { capitalizeFirstLetter, insertSpaceBeforeCapitalLetters, lowercaseFirstLetter } from "../Util/helper";

// Function to display selected meat types as badges
export function displayDropdownOptions(dropdownId, containerId, selectedValues) {
    const selectedContainer = document.getElementById(containerId);

    if (!selectedContainer) {
        console.error('Selected container not found. The container should have the same ID as the dropdown with "-selected" appended.');
        return;
    }

    selectedContainer.innerHTML = '';

    selectedValues.forEach(value => {
        const badge = document.createElement('span');
        badge.className = 'badge badge-primary flex items-center m-1';

        let name = t('dropdown.' + capitalizeFirstLetter(value));

        if (name.includes('dropdown.')) {
            name = capitalizeFirstLetter(insertSpaceBeforeCapitalLetters(value));
        }

        badge.innerHTML = `
            ${name}
            <button type="button" class="ml-2" onclick="App.common.removeSelection('${dropdownId}', '${containerId}', '${value}')">
                <i class="fa-solid fa-times cursor-pointer"></i>
            </button>
        `;
        selectedContainer.appendChild(badge);
    });
}

export function markDropdownSelection(value) {
    const checkbox = document.getElementById(value);
    if (checkbox) {
        checkbox.checked = true;
        updateSelection(checkbox);
    }
}   

// Function to remove a selected meat type
export function removeDropdownSelection(dropdownId, containerId, value) {
    const checkbox = document.getElementById(value);
    if (checkbox) {
        checkbox.checked = false;
        updateSelection(checkbox);
    }
}

// Function to toggle the dropdown
export function toggleSelectDropdown(id) {
    const dropdown = document.getElementById(id);
    dropdown.classList.toggle('hidden');
}

// Function to update the selected
export function updateSelection(checkbox) {
    const dId = checkbox.getAttribute('dropdown');
    const containerId = dId + '-selected';
    const selectedValues = Array.from(document.querySelectorAll('#' + dId +' input[type="checkbox"]:checked'))
        .map(cb => cb.value)
    displayDropdownOptions(dId, containerId, selectedValues);

    eventBus.emit('selection:update', {selectedValues, dId});
    return selectedValues;
}

export function getSelectedValues(dropdownId) {
    const selectedValues = Array.from(document.querySelectorAll('#' + dropdownId + ' input[type="checkbox"]:checked'))
        .map(cb => capitalizeFirstLetter(insertSpaceBeforeCapitalLetters(cb.value)));
    return selectedValues;
}

// Function to add a new meat type to the selection list
export function addDropdownOption(dId, newOption) {
    if (newOption) {
        // check if the option starts with a capital letter
        if (newOption[0] !== newOption[0].toUpperCase()) {
            newOption = capitalizeFirstLetter(newOption);
        }
        const dropdown = document.getElementById(dId);
        const li = document.createElement('li');
        const newOptionId = lowercaseFirstLetter(newOption.replaceAll(' ', ''));
        li.className = 'p-2';
        li.innerHTML = `
            <label class="flex items-center cursor-pointer">
                <input type="checkbox" class="checkbox checkbox-primary" dropdown="${dId}" value="${newOptionId}" id="${newOptionId}" onchange="App.common.updateSelection(this)">
                <span class="ml-2" style="font-size: 1rem; margin-bottom: 7px; cursor: pointer;">${t("dropdown." + newOption)}</span>
            </label>
        `;
        dropdown.querySelector('ul').appendChild(li);
    }

    if (document.getElementById(dId)) {
        document.addEventListener('click', function(event) {
            const dropdown = document.getElementById(dId);
            const button = dropdown.previousElementSibling;
            if (!button.contains(event.target) && !dropdown.contains(event.target)) {
                dropdown.classList.add('hidden');
            }
        });
    } else {
        console.error('Dropdown not found');
    }
}